import React from "react"
import { MainCP } from "../../Components/recordacion-rostros-publicitarios/MainCP"

const ViewRecordacionRostrosPublicitarios: React.FC = () => <MainCP/>

export default ViewRecordacionRostrosPublicitarios